import { ItemResolver } from './ItemResolver';
import { pageFacet, childItemsFacet } from '../../facets/SetFacets';
import { pack } from '../Facet';
import { ArraySpliceMatchPatch } from '../../utilities/Graft';

/**
 * Resolves a page into a 'new' state, where the child items are not yet resolved.
 * If the page had previously been evaluated, its state is reset.
 *
 * Use this function when when discovering a paging token while parsing an API respone.
 */
export function resolveNewPage(payload: {
  itemKey: string;
}): {
    itemResolver: ItemResolver;
  } {
  const {
    itemKey
  } = payload;

  const itemResolver = new ItemResolver();

  itemResolver.resolveItems({
    items: {
      [itemKey]: {
        ...pageFacet.pack({})
      }
    }
  });

  itemResolver.invalidateItems({
    items: {
      [itemKey]: [childItemsFacet]
    }
  });

  return {
    itemResolver
  };
}

/**
 * Resolves an existing page with known child items, inserting it into the host item set.
 *
 * Use this function when parsing the items after fetching a paging token.
 */
export function resolveExistingPage(payload: {
  itemKey: string;
  itemSetKey: string;
  childItemKeys: string[];
}): {
    itemResolver: ItemResolver;
  } {
  const {
    itemKey,
    itemSetKey,
    childItemKeys
  } = payload;

  const itemResolver = new ItemResolver();

  itemResolver.resolveItems({
    items: {
      [itemKey]: {
        ...pageFacet.pack({}),
        ...childItemsFacet.pack(undefined)
      },
      [itemSetKey]: pack({
        childItems: childItemsFacet
      }, {
          childItems: {
            itemKeys: new ArraySpliceMatchPatch((childItemKey: string) => childItemKey === itemKey, childItemKeys)
          }
        })
    }
  });

  return {
    itemResolver
  };
}
